export const ANIMATION_TIMEOUT = 300;
export const ANIMATION_TIMEOUT_MIDDLE = 450;
